import { lostEditSentence, type LostEdit } from "../studio/lost-edits.ts";
import type { ValidationIssue } from "./adapter.ts";

/**
 * The Issues for studio edits whose frame a new version of a sorted pack lacks (ADR-107 E8). The compile that wrote
 * the editor's catalogue names them (`EditorCatalogue.lostEdits`); each is one warning of the map in view, in the
 * studio's own words. A world that places the frame fails its compile as for any missing frame, so the line does
 * not offer to fix anything: the edit waits in the studio for the frame to come back.
 */

/**
 * The kind of the Issue; the line is not ignorable.
 */
export const LOST_EDIT_KIND = "studio.lost-edit";

/**
 * The lost edits of the catalogue, each as one warning of the map in view.
 *
 * @param mapId The map the lines are listed with.
 * @param lost The entries the last compile found their frames gone for; anything but a list reads as none, and an entry that is not a label with a known kind is skipped.
 * @returns One warning an entry, in the list's order.
 */
export function lostEditIssues(mapId: string, lost: readonly LostEdit[] | undefined): ValidationIssue[] {
  if (!Array.isArray(lost)) {
    return [];
  }
  const known = (lost as readonly unknown[]).filter((entry): entry is LostEdit => typeof entry === "object" && entry !== null && typeof (entry as LostEdit).label === "string" && ((entry as LostEdit).kind === "frame" || (entry as LostEdit).kind === "animation"));
  return known.map((entry): ValidationIssue => ({ mapId, kind: LOST_EDIT_KIND, severity: "warning", message: lostEditSentence(entry) }));
}
